import { isError } from 'flux-standard-action';
import { payloadExtractor } from 'app-webtech-core/reducers/payloadExtractor';
import { updateState } from 'app-webtech-core/reducers/updateState';

const requestMutationGenerator = ({ notClearReveal }, { revealAnswer }) => ({
  isOnline: { $set: true },
  loadedData: { $set: null },
  revealAnswer: { $set: notClearReveal ? revealAnswer : false },
  error: { $set: null },
});

const successMutationGenerator = ({ answerTimeout, id, choices, points, title }) => ({
  loadedData: {
    $set: {
      answerTimeout,
      id,
      choices,
      points,
      title,
    },
  },
});

const errorMutationGenerator = (error) => ({
  isOnline: { $set: false },
  loadedData: { $set: null },
  error: { $set: error.stack },
});

export const triviaLoadRequestReducer = (currentState, action) =>
  updateState(
    currentState,
    (isError(action) ? errorMutationGenerator : requestMutationGenerator)(
      payloadExtractor(action),
      currentState,
    ),
  );

export const triviaLoadSuccessReducer = (currentState, action) =>
  updateState(
    currentState,
    (isError(action) ? errorMutationGenerator : successMutationGenerator)(payloadExtractor(action)),
  );

export const triviaLoadFailureReducer = (currentState, action) =>
  updateState(currentState, errorMutationGenerator(payloadExtractor(action)));
